export default [
    { // все оценочные листы
        path: '/marking_list/:id', 
        name: 'Markinglist',
        props: true,
        component: () => import(/* webpackChunkName: "about" */ '../../../views/marking_list/list.vue'),
        meta: { 
            requiresAuth: true
        }
    },
    { // все оценочные листы
        path: '/marking_list/:id/new', 
        name: 'NewMarkinglist',
        props: true,
        component: () => import(/* webpackChunkName: "about" */ '../../../views/marking_list/new.vue'),
        meta: { 
            requiresAuth: true
        }
    },
    { // просмотр аспектов оценочного листа
        path: '/marking_list/show/:list_id',
        name: 'ShowMarkinglist',
        props: true,
        component: () => import(/* webpackChunkName: "about" */ '../../../views/marking_list/show.vue'),
        meta: { 
            requiresAuth: true
        }
    },
]